/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Frame) GS.Toolbar.Frame={};
GS.Toolbar.Frame.BackgroundTools=new Class({
    Extends: GS.Toolbar.Tools,
    class_name:'GS.Toolbar.BackgroundTools',
    options:{
        'wrapper': null,
        'class':'submenu full',
        'lexico':{'x':'X','y':'Y','o':'O','b':'B'},
        'toolbar':null
    },
    controlled:null,
    initialize:function(conf){
       this.options.lexico=Locale.get('Toolbar.framebackground');
       this.parent(conf);
    }
});



GS.Toolbar.Frame.BackgroundTools.prototype.addListeners=function(obj,evs){
    if(!evs.pop) evs=[evs];
    //console.debug('@BackgroundTools Add Event %s',evs);
    Array.each(evs,function(p,i){
        //console.debug('Add Event %s',p);
        obj.addEvent(p,function(v){
            //this.fireEvent.apply(this,arguments);
        });
    }.bind(this));
};

GS.Toolbar.Frame.BackgroundTools.prototype.updatePermissions=function(p){
    var d,s;
    //console.log('Update permission....',p);
    try{
        d=(p.backgroundtools) ? 'block' : 'none';
        s=(p.backgroundtools) ? 1 : 0;
        
       
        if(p.backgroundtools){
            this.fireEvent('frame:backgroundcolor',p.backgroundtools['framebackgroundcolor'] || 0);
            this.fireEvent('chained:backgroundcolor',p.backgroundtools['chained:backgroundcolor'] || 0);
            this.fireEvent('colorize:object',p.backgroundtools['colorize'] || 0);
        }
        
        this.options.wrapper.setStyle('display',d);
        this.options.wrapper.store('status',1);
        if(s) this.toolbar.fireEvent('show');
    }catch(err){}
};



GS.Toolbar.Frame.BackgroundTools.prototype.configureTools=function(){
   
    var self=this,
        ctrl,w/*,type,ui*/;
    
    this.sm=new Element('ul',{'class':this.options['class']}).set('html',this.menuTMPL().substitute(this.options.lexico));
    ctrl=this.sm.getElements('li');
    w=this.options.wrapper;
    
    //console.warn("configureTools@GS.Toolbar.Frame.BackgroundTools",ctrl);
   // var t=this.toolbar;
    Array.each(ctrl,function(ctr,i){
        var type=ctr.getAttribute('data-type'),
            ui=ctr.getAttribute('data-uitype'),
                _nextSibling = ctr.nextElementSibling;
            
            
            if(!_nextSibling || _nextSibling.nodeName === '#text') {
                _nextSibling = null;
            }else{
                $(_nextSibling);
            }
            //console.debug(_nextSibling,ctr.nextSibling,ctr);

        switch(ui){
            case 'slider_w_input':
            case 'slider':
                var currentAlpha=1, changed = 0,
                    sl=new GS.Toolbar.Slider(ctr,{'debug':0,'property':type,'value':0});
                
                sl.addEvent('change',function(v){
                    currentAlpha = v;
                    //console.debug(type+':set',v);
                    if(type === 'framebackground-color-opacity') currentAlpha = v/100;
                   // if(typeof v !== 'undefined') self.controlled.setFrameBackgroundColor(v,'opacity',false);
                    self.fireEvent(type+':set',currentAlpha);
                    if(sl.inputField) sl.inputField.setValue(v);
                    if(typeof v !== 'undefined') self.controlled.fireEvent(type+':set',currentAlpha);
                });
                
                if(ui == "slider_w_input"){
                    sl.inputField = new GS.Toolbar.Input(ctr,{'property':type});
                    sl.inputField.addEvent('input:change',function(v){
                        if(type === 'framebackground-color-opacity') currentAlpha = v/100;
                        sl.fireEvent('set',v);
                        if(sl.inputField) sl.inputField.setValue(Number(v));
                        if(self.controlled) {
                            self.controlled.fireEvent(type+':set',currentAlpha);
                            self.controlled.fireEvent(type+':end');
                        }
                        self.dispatch('user:interaction',1);
                        /*
                        var val = (!isNaN(v) && type === 'shadow-opacity') ? v/100 : v;
                        sl.fireEvent('set',v);
                        if(self.controlled) {
                            self.controlled.fireEvent(type+':set',val);
                            self.controlled.fireEvent(type+':end');
                        }*/
                        
                    });
                }
                
                sl.addEvent('start',function(){
                    changed = 1;
                   // if(self.controlled) self.controlled.fireEvent('framebackground:color:opacity:start');  
                });
                
                sl.addEvent('end',function(){
                    if(changed && self.controlled) self.controlled.fireEvent(type+':end');
                    self.dispatch('user:interaction',1);
                });
                switch(type){
                    case 'opacity':
                        sl.setMinMax(0,1);
                        self.sm.addEvent('show',function(active){
                           if(!self.controlled.getFrameBackgroundColor) return;
                           currentAlpha = self.controlled.getFrameBackgroundColor('opacity');
                           sl.fireEvent('set',currentAlpha);
                        });
                        self.addEvent('opacity',function(active){
                        
                        });
                    break;
                    case 'framebackground-color-opacity':
                        self.addEvent('frame:backgroundcolor',function(v){
                            if(v){
                                ctr.setStyle('display','block');
                                if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','block');
                            }else{
                                ctr.setStyle('display','none');
                                if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','none');
                            }
                        });
                        sl.setMinMax(0,100,0.1);
                        self.sm.addEvent('show',function(active){
                            if(!self.controlled) return;
                            self.controlled.fireEvent(type+':get',function(_o){
                                if(_o === null){
                                    sl.fireEvent('disabled',1);
                                }else{
                                    sl.fireEvent('disabled',0);
                                    currentAlpha = _o;
                                    sl.fireEvent('set',Number(currentAlpha*100));
                                    if(sl.inputField) sl.inputField.setValue(Number(currentAlpha*100));
                                }
                            });
                          
                        });
                    break;
                    case 'trama-opacity':
                        sl.setMinMax(0,1);
                        var _input = ctr.getElement('[name="trama-input-value"]');
                        if(_input){
                            self.addEvent(type+':set',function(v){
                                if(_input) _input.value=(v*100).toFixed(0);
                            });
                            _input.addEvent('focus',function(e){
                                if(e) {
                                    e.stop();
                                    e.preventDefault();
                                }
                            });
                            _input.addEvent('click',function(e){
                                if(e) {
                                    e.stop();
                                    e.preventDefault();
                                }
                            });
                            _input.addEvent('change',function(e){
                                changed = 1;
                                if(e) {
                                    e.stop();
                                    e.preventDefault();
                                }
                                var v = Number(this.value)/100;
                                if(v>1){
                                    v=1;
                                    this.value=100;
                                }
                                if(v<0){
                                    v=0;
                                    this.value=0;
                                }
                                //this.value=v;
                                sl.fireEvent('set',v);
                                self.controlled.fireEvent(type+':set',v);
                                self.controlled.fireEvent(type+':end');
                            });
                        }
                        
                        self.sm.addEvent('show',function(active){
                            //console.warn('Get trama opacity using event: "%s"',type+':get');
                            if(!self.controlled) return;
                            self.controlled.fireEvent(type+':get',function(_o){
                                if(_o === null){
                                    sl.fireEvent('disabled',1);
                                }else{
                                    sl.fireEvent('disabled',0);
                                    currentAlpha = _o;
                                    sl.fireEvent('set',currentAlpha);
                                    if(_input) _input.value=(currentAlpha*100).toFixed(0);
                                }
                            });
                          
                        });
                       
                        self.addEvent('colorize:object',function(v){
                           if(v){
                               ctr.setStyle('display','block');
                               if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','block');
                           }else{
                               ctr.setStyle('display','none');
                               if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','none');
                           }
                        });
                    break;
                    
                }
            break;
            case 'chain:colors':
                var chained = 0;
                self.addEvent('chained:backgroundcolor',function(v){
                    //console.debug('chained:backgroundcolor',v);
                    if(v){
                        ctr.setStyle('display','block');
                        if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','block');
                    }else{
                        ctr.setStyle('display','none');
                        if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','none');
                    }
                 });
                self.sm.addEvent('show',function(active){
                            
                    //console.debug('Get frame background color opacity....'); 
                    if(!self.controlled) return;
                    self.controlled.fireEvent('chain:colors:get',function(_chained){
                        chained = _chained;
                        self.fireEvent('chained',_chained);
                        if(chained) {
                            ctr.addClass('active');
                        }else{
                            ctr.removeClass('active');
                        }
                    });
                });
                
                ctr.addEvent('click',function(e){
                    e.stop();
                    if(!self.controlled) return;
                    chained = !chained ? 1 : 0;
                    //console.warn('chained: %s',chained, type);
                    self.controlled.fireEvent('chain:colors:set',chained);
                    if(chained) {
                        ctr.addClass('active');
                    }else{
                        ctr.removeClass('active');
                    }
                    self.fireEvent('chained',chained);
                    
                });
            break;
            case 'colorpicker':
                //var ev,
                
                //var lEle= $j('#toolbar-framebackground-color'),
                var ev,
                    _chained = -1,
                    cPreview=ctr.getElement('.color-placeholder'),
                    currentColor='#000000',
                    lastRGB = null,
                    changed = 0, cp, 
                    _active = null,
                    onMouseUp = function(){
                        //console.debug('Last RGB',lastRGB);
                        if(lastRGB){
                            if(self.controlled) {
                                self.controlled.fireEvent(ev+':set',lastRGB);
                                self.controlled.fireEvent(ev+':end');
                            }
                           // if(self.controlled) self.controlled.setFrameBackgroundColor(lastRGB,'color',true);
                            lastRGB = null;
                        }
                    };
                    
                switch(ctr.id){
                    case 'toolbar-framebackground-color-left':
                        ev = 'backgroundcolor:left';
                    break;
                    case 'toolbar-framebackground-color-right':
                        ev = 'backgroundcolor:right';
                    break;
                    case 'toolbar-whitepoint-color':
                        ev = 'object-whithepoint-color';
                    break;
                    case 'toolbar-blackpoint-color':
                        ev = 'object-blackpoint-color';
                    break;
                    case 'framebackground-color':
                        ev = 'framebackground-color';
                    break;
                }
                //console.warn('----->', type);
                switch(type){
                    case 'object-whithepoint-color':
                    case 'object-blackpoint-color':
                        
                        
                    
                        self.sm.addEvent('show',function(active){
                            if(!self.controlled) return;
                            self.controlled.fireEvent('object-dualtone-color:get',function(_ev,_color){
                                //console.debug('ev: %s',_ev,_color);
                                if(_color) currentColor = _color;
                                if(_ev){
                                    ev = _ev;
                                    cPreview.setStyle('background-color',currentColor);
                                  //  ctr.setStyle('display','block');
                                }else{
                                  //  ctr.setStyle('display','none');
                                }
                                
                            });
                        });
                        self.addEvent('colorize:object',function(v){
                            //console.debug('colorize:object',v);
                            if(v){
                                ctr.setStyle('display','block');
                                if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','block');
                            }else{
                                ctr.setStyle('display','none');
                                if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','none');
                            }
                        });
                    break;
                    case 'framebackground-color':
                        self.sm.addEvent('show',function(active){
                            if(!self.controlled) return;
                            self.controlled.fireEvent(ev+':get',function(_color){
                                if(_color) {
                                    currentColor = _color;
                                     cPreview.setStyle('background-color',currentColor);
                                }
                            });
                        });
                        self.addEvent('frame:backgroundcolor',function(v){
                            if(v){
                                ctr.setStyle('display','block');
                                if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','block');
                            }else{
                                ctr.setStyle('display','none');
                                if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','none');
                            }
                        });
                    break;
                    default:
                        _chained = 0;
                        self.addEvent('chained:backgroundcolor',function(v){
                            if(v){
                                ctr.setStyle('display','block');
                                if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','block');
                            }else{
                                ctr.setStyle('display','none');
                                if(_nextSibling && _nextSibling.className === 'separetor-h') _nextSibling.setStyle('display','none');
                            }
                        });
                        self.addEvent('chained',function(c){
                            _chained = c;
                        });

                        self.addEvent('bgcolor:change',function(color){
                            if(_chained){
                                currentColor = '#'+color;
                                cPreview.setStyle('background-color',currentColor);
                            }
                        });
                        
                        self.sm.addEvent('show',function(active){
                            if(!self.controlled) return;
                            self.controlled.fireEvent(ev+':get',function(_color){
                                currentColor = _color;
                                
                                cPreview.setStyle('background-color',currentColor);
                            });
                        });
                    break;
                }

                if(window.$j) {
                    var cp = $j(ctr).ColorPicker({
                        color: currentColor,
                        flat: false,
                        /*eventName : 'mouseup',*/
                        onShow: function (colpkr) {
                            $j(colpkr).fadeIn(500);
                            $j(colpkr).bind('mouseup', onMouseUp);
                            _active = ctr;
                            return false;
                        },
                        onHide: function (hsb, hex, rgb, el) {
                            $j(el).fadeOut(500);
                            currentColor = null;
                            if (changed && self.controlled) self.controlled.fireEvent(ev + ':end');
                            //if(changed && self.controlled) self.controlled.setFrameBackgroundColor(rgb,'color',true);
                            changed = 0;
                            lastRGB = null;
                            $j(el).unbind('mouseup', onMouseUp);
                            self.dispatch('user:interaction', 1);
                            return false;
                        },
                        onSubmit: function (hsb, hex, rgb, el) {
                            console.info('asioidsaoidsa');
                        },
                        onChange: function (hsb, hex, rgb) {
                            changed = 1;
                            lastRGB = rgb;
                            lastRGB.hex = hex;
                            cPreview.setStyle('background-color', 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')');
                            //if(self.controlled) self.controlled.setFrameBackgroundColor(rgb,'color',false);
                            console.warn('---->', ev);
                            if (self.controlled) self.controlled.fireEvent(ev + ':set', lastRGB);
                            if (_chained !== -1) self.fireEvent('bgcolor:change', hex);
                            return false;
                        },
                        onMouseUp: function (hsb, hex, rgb) {
                            //console.debug('Mouseup....');
                        },
                        onBeforeShow: function () {
                            changed = 0;
                            lastRGB = null;
                            //console.warn('Current color picker color is: ',currentColor,this.color);
                            if (currentColor) $j(this).ColorPickerSetColor(currentColor);
                        }
                    });
                }
        }
    });
    
    w.addEvent('click',function(e){
        e.stop();
        //console.debug('....');
        if(e.event.target !== w && w.contains(e.event.target)) return;
        var s=(self.sm.getStyle('display')!=='block') ? 'block' : 'none';
        self.sm.setStyle('display',s);
        (s==='block') ? this.addClass('selected') : this.removeClass('selected');
        self.toolbar.fireEvent('submenu:show',this);
    });
    
    w.setAttribute('title',this.options.lexico['menu_tooltip']);
    w.empty().adopt(this.sm);
};


GS.Toolbar.Frame.BackgroundTools.prototype.menuTMPL=function(){
    //var out='      <li class="slider shadow-x" data-type="opacity" data-uitype="slider" title="{tooltip_o}"><label class="min">{oMin}</label><label>{o}</label><label class="max">{oMax}</label></li>';
    //out+='      <li class="slider shadow-color" data-type="color"  id="toolbar-framebackground-color" data-uitype="colorpicker"><div class="color-placeholder"  title="{tooltip_c}"></div></li>';
    
    //out+= ''
    var out='   <li class="point-color" data-type="object-whithepoint-color"  id="toolbar-whitepoint-color" data-uitype="colorpicker" title="{tooltip_2t}"><label>{trama_title}</label><div class="color-placeholder"></div></li>';
     out+= '    <li class="slider shadow-x" data-type="trama-opacity" data-uitype="slider" title="{tooltip_o}"><label class="min">{oMin}</label><label>{o}</label><label class="max">{oMax}</label><input type="number" name="trama-input-value" value="" min="0" max="100"/></li>';
    //out+='      <li class="point-color" data-type="object-blackpoint-color"  id="toolbar-blackpoint-color" data-uitype="colorpicker" title="{tooltip_c}"><div class="color-placeholder"></div></li>';
    out+= '     <li class="separator-h"></li>';
    out+= '     <li class="left-page-color" data-type="color"  id="toolbar-framebackground-color-left" data-uitype="colorpicker"><label>{pages_color_title}</label><div class="color-placeholder"  title="{tooltip_c}"></div></li>';
    out+= '     <li class="chain" data-type="chain-colors" data-uitype="chain:colors">';
    out+= '     <svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="21.989px" height="8.997px" viewBox="0 0 21.989 8.997" enable-background="new 0 0 21.989 8.997" xml:space="preserve">\
                    <g id="chained">\
                            <path d="M21.971,3.002c-0.013-1.479-1.31-2.694-2.899-2.71l-3.973-0.046c-1.59-0.019-2.873,1.168-2.862,2.644l2.252,0.042\
                                    c0.235-0.435,0.781-0.675,1.345-0.67l2.526,0.03c0.798,0.011,1.446,0.616,1.45,1.355l0.013,2.011\
                                    c0.005,0.739-0.635,1.33-1.432,1.322l-2.527-0.028c-0.534-0.007-1.124-0.285-1.375-0.691l-2.23-0.02\
                                    c0.01,1.479,1.308,2.692,2.899,2.71l3.968,0.046c1.594,0.02,2.875-1.166,2.864-2.646L21.971,3.002z M6.058,6.854L3.696,6.828\
                                    c-0.81-0.01-1.47-0.627-1.475-1.381L2.205,3.399C2.2,2.648,2.857,2.042,3.665,2.053l2.363,0.026\
                                    c0.574,0.008,1.137,0.264,1.381,0.715l2.294,0.01C9.693,1.298,8.369,0.061,6.75,0.042L2.918,0C1.297-0.018-0.009,1.188,0,2.695\
                                    l0.02,3.411c0.011,1.504,1.334,2.741,2.955,2.76l3.832,0.043C8.428,8.926,9.733,7.72,9.725,6.215L7.45,6.181\
                                    C7.202,6.589,6.605,6.859,6.058,6.854z M6.71,4.526C6.708,5.033,7.15,5.448,7.7,5.452l6.608,0.016\
                                    c0.55,0.002,0.995-0.408,0.996-0.919c0.001-0.507-0.441-0.921-0.988-0.923L7.708,3.608C7.159,3.606,6.714,4.016,6.71,4.526z"/>\
                    </g>\
                    \
                    <g id="unchained">\
                            <path d="M21.971,3.002c-0.013-1.479-1.31-2.694-2.899-2.71l-3.973-0.046c-1.59-0.019-2.873,1.168-2.862,2.644l2.252,0.042\
                                    c0.235-0.435,0.781-0.675,1.345-0.67l2.526,0.03c0.798,0.011,1.446,0.616,1.45,1.355l0.013,2.011\
                                    c0.005,0.739-0.635,1.33-1.432,1.322l-2.527-0.028c-0.534-0.007-1.124-0.285-1.375-0.691l-2.23-0.02\
                                    c0.01,1.479,1.308,2.692,2.899,2.71l3.968,0.046c1.594,0.02,2.875-1.166,2.864-2.646L21.971,3.002z M6.058,6.854L3.696,6.828\
                                    c-0.81-0.01-1.47-0.627-1.475-1.381L2.205,3.399C2.2,2.648,2.857,2.042,3.665,2.053l2.363,0.026\
                                    c0.574,0.008,1.137,0.264,1.381,0.715l2.294,0.01C9.693,1.298,8.369,0.061,6.75,0.042L2.918,0C1.297-0.018-0.009,1.188,0,2.695\
                                    l0.02,3.411c0.011,1.504,1.334,2.741,2.955,2.76l3.832,0.043C8.428,8.926,9.733,7.72,9.725,6.215L7.45,6.181\
                                    C7.202,6.589,6.605,6.859,6.058,6.854z"/>\
                    </g>\
                </svg>';
    out+='      </li>';
    out+='      <li class="right-page-color" data-type="color"  id="toolbar-framebackground-color-right" data-uitype="colorpicker"><div class="color-placeholder"  title="{tooltip_c}"></div></li>';
    out+= '     <li class="separator-h"></li>';
    out+='      <li class="point-color" data-type="framebackground-color"  id="framebackground-color" data-uitype="colorpicker" title="{tooltip_2t}"><label>{frame_color_title}</label><div class="color-placeholder"></div></li>';
    out+= '     <li class="slider shadow-x" data-type="framebackground-color-opacity" data-uitype="slider_w_input" title="{tooltip_o}"><label class="min">{oMin}</label><label>{o}</label><label class="max">{oMax}</label></li>';
    return out;
};